import { render, staticRenderFns } from "./VaimoProductCard.vue?vue&type=template&id=4bd09b0c&scoped=true&"
import script from "./VaimoProductCard.vue?vue&type=script&lang=ts&"
export * from "./VaimoProductCard.vue?vue&type=script&lang=ts&"
import style0 from "./VaimoProductCard.vue?vue&type=style&index=0&id=4bd09b0c&prod&lang=scss&scoped=true&"
import style1 from "./VaimoProductCard.vue?vue&type=style&index=1&id=4bd09b0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd09b0c",
  null
  
)

export default component.exports